export const INITIAL_QUIZ_STREAM = { streamingReply: '', committed: null, errored: null };

/**
 * Pure reducer over the quiz-grading SSE events. UX decision A: `stage` events
 * are not surfaced (the token stream is the progress). See the design spec.
 */
export function applyQuizStreamEvent(state, { event, data }) {
  switch (event) {
    case 'token':
      return { ...state, streamingReply: state.streamingReply + (data.text ?? '') };
    case 'complete':
      return {
        ...state,
        committed: {
          assistantMessage: data.assistantMessage,
          status: data.status,
          score: data.score ?? null,
          feedback: data.feedback ?? null,
          courseJustCompleted: !!data.courseJustCompleted,
        },
      };
    case 'error':
      return { ...state, errored: { message: data.message || 'We couldn’t grade your answer. Please try again.' } };
    case 'stage':
    default:
      return state;
  }
}
